/**
 * Catálogo de relatórios agendáveis.
 *
 * Hoje existe apenas uma tool: `utilizations` (relatório de utilização).
 * A estrutura de lista foi mantida porque o backend é genérico por `tool_key`
 * e novas tools devem aparecer sem refatorar o form.
 *
 * TODO(PED-12415): trocar por um `GET /notification-tools` quando existir —
 * não há endpoint público que liste as tools, então a chave é hardcodada.
 * Enviar uma `tool_key` inexistente ou inativa devolve 400.
 */
export const REPORT_TOOLS = [
  {
    toolKey: "utilizations",
    labelKey: "schedule-report-utilization",
  },
] as const;

export const REPORT_TOOL_KEYS = REPORT_TOOLS.map((tool) => tool.toolKey) as [
  string,
  ...string[],
];

export function getReportToolLabelKey(toolKey: string): string | undefined {
  return REPORT_TOOLS.find((tool) => tool.toolKey === toolKey)?.labelKey;
}
